// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-a-biaodancaidanmingdan[data-v-45bdfaad]{color:#2cb774;font-size:18px;font-weight:700;cursor:pointer}", ""]);
// Exports
module.exports = exports;
